import styled, { keyframes } from 'styled-components';

const fade1 = keyframes`
  0% { fill: #7c878e; }
  20% { fill: #003da5; }
  80% { fill: #003da5; }
  100% { fill: #7c878e; }
`;

const fade2 = keyframes`
  0% { fill: #7c878e; }
  20% { fill: #7c878e; }
  40% { fill: #003da5; }
  80% { fill: #003da5; }
  100% { fill: #7c878e; }
`;

const fade3 = keyframes`
  0% { fill: #7c878e; }
  40% { fill: #7c878e; }
  60% { fill: #003da5; }
  80% { fill: #003da5; }
  100% { fill: #7c878e; }
`;

export const StyledLoader = styled.div`
  position: relative;
  width: 72px;
  height: 54px;
  margin: 0 auto;
`;

export const StyledLeg = styled.polygon`
  animation: 1s linear 0s infinite normal none running ${fade1};
`;

export const StyledBody = styled.path`
  animation: 1s linear 0s infinite normal none running ${fade2};
`;

export const StyledHead = styled.path`
  animation: 1s linear 0s infinite normal none running ${fade3};
`;
